const t = (r) => r == null ? "" : String(r);
export {
  t as getFormControlValueAsString
};
